export const EVENT_PERFORMANCE_PAGE_CONST = {
    localStorage: {
        sidebarCollapsedKey: 'eventPerformanceSidebarCollapsed',
    },
    collapsedWidth: 40,
    expandedWidth: 260,
    tabContentHeight: 'calc(100vh - 156px)', // Adjusted to match the height of the sidebar content
};
